module.exports = __webpack_public_path__ + "img/1-en.4b24d607.png";